import Axios from 'axios';

class api {

  instanciaAxios = null;

  constructor () {
    this.instanciaAxios = Axios.create ({
      baseURL: process.env.VUE_APP_URL_BASE_BACKEND,
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
  }

  // control de sesion
  establecerAccessToken (access_token) {
    this.instanciaAxios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`
  }

  eliminarAccessToken () {
    delete this.instanciaAxios.defaults.headers.common['Authorization']
  }

  iniciarSesion (email, password) {
    let peticion = {
      correoElectronico: email,
      contrasena: password
    };
    return this.instanciaAxios.post('/sesion/iniciar', peticion)
  }

  cerrarSesion () {
    return this.instanciaAxios.post('/sesion/cerrar')
  }

  obtenerDatosSesion () {
    return this.instanciaAxios.get('/sesion/datos')
  }

  guardarDatosSesion (datos) {
    return this.instanciaAxios.post (`/sesion/datos`, datos)
  }

  recuperarContrasena (email) {
    let peticion = {
      correoElectronico: email
    }
    return this.instanciaAxios.post('/recuperar_contrasena', peticion)
  }

  restablecerContrasena (tokenSeguridad, nuevaContrasena) {
    let peticion = {
      tokenSeguridad: tokenSeguridad,
      nuevaContrasena: nuevaContrasena
    };
    return this.instanciaAxios.post ('/restablecer_contrasena', peticion)
  }

  guardarPreferenciasOperador (preferencias) {
    return this.instanciaAxios.post('/preferencias_operador', preferencias)
  }

  //------------------------

  // sistema
  obtenerParametrosConfiguracion () {
    return this.instanciaAxios.get ("/parametros_configuracion")
  }
  obtenerTablasConsulta (parametros) {
    return this.instanciaAxios.get ('/tablas_consulta', { params: parametros })
  }
  obtenerInformacionEstadoSistema () {
    return this.instanciaAxios.get ("/informacion_estado_sistema")
  }
  ejecutarSQL (datos) {
    return this.instanciaAxios.post ("/ejecutar_sql", datos)
  }
  importarDatosSAGA (datos) {
    return this.instanciaAxios.post ("/importar_datos_saga", datos)
  }

  // CRUD
  obtenerRegistrosTablaVista (modeloDatos, parametros, controlErrores = true) {
    return this.instanciaAxios.get (`/base_datos/${modeloDatos}`, { params: parametros, _opciones: { controlErrores: controlErrores } })
  }
  anadirRegistroTablaVista (modeloDatos, registro, controlErrores = true) {
    return this.instanciaAxios.post (`/base_datos/${modeloDatos}`, registro, { _opciones: { controlErrores: controlErrores } })
  }
  modificarRegistroTablaVista (modeloDatos, registro, claveRegistro, controlErrores = true) {
    return this.instanciaAxios.put (`/base_datos/${modeloDatos}`, registro, { params: claveRegistro, _opciones: { controlErrores: controlErrores } })
  }
  eliminarRegistroTablaVista (modeloDatos, claveRegistro, controlErrores = true) {
    return this.instanciaAxios.delete (`/base_datos/${modeloDatos}`, { params: claveRegistro, _opciones: { controlErrores: controlErrores } })
  }
  loteCambiosRegistrosTablaVista (modeloDatos, registros, claveRegistro, controlErrores = true) {
    if (registros.insertar.length > 0 || registros.actualizar.length > 0 || registros.eliminar.length > 0)
      return this.instanciaAxios.patch (`/base_datos/${modeloDatos}`, registros, { params: claveRegistro, _opciones: { controlErrores: controlErrores } })
  }

  // OMD: operacion modelo de datos
  gmd (peticion) {
    return this.instanciaAxios.post (`/omd`, peticion)
  }

  // general
  obtenerTiposPases (parametros) {
    return this.instanciaAxios.get (`/tipos_pases`, { params: parametros })
  }
  obtenerZonasAccesoPase (parametros) {
    return this.instanciaAxios.get (`/zonas_acceso_pase`, { params: parametros })
  }
  obtenerZonasAccesoTipoPase (parametros) {
    return this.instanciaAxios.get (`/zonas_acceso_tipo_pase`, { params: parametros })
  }
  obtenerPlazasDisponiblesTipoPase (parametros) {
    return this.instanciaAxios.get (`/plazas_no_asignadas`, { params: parametros })
  }
  obtenerDisponibilidadIdentificadorPase (parametros) {
    return this.instanciaAxios.get (`/disponibilidad_identificador_pase`, { params: parametros })
  }
  obtenerEstadisticasEmpresaInquilina (parametros) {
    return this.instanciaAxios.get ('/estadisticas_empresa_inquilina', { params: parametros })
  }
  obtenerInstalacionesOperador () {
    return this.instanciaAxios.get ("/instalaciones_operador")
  }

  // reservas
  obtenerGestionReservasPases (parametros) {
    return this.instanciaAxios.get (`/gestion_reservas/pases`, { params: parametros })
  }
  obtenerGestionReservasPlazasDisponibles (parametros) {
    return this.instanciaAxios.get (`/gestion_reservas/plazas_disponibles`, { params: parametros })
  }

  // cesiones de plazas
  obtenerGestionCesionesPlazasPases (parametros) {
    return this.instanciaAxios.get (`/gestion_cesiones_plazas/pases`, { params: parametros })
  }

  // visitas
  obtenerGestionVisitasPlazasDisponibles (parametros) {
    return this.instanciaAxios.get (`/gestion_visitas/plazas_disponibles`, { params: parametros })
  }

  // sinoptico
  obtenerInstalacionesAparatosInterfoniasCamaras (parametros) {
    return this.instanciaAxios.get (`/instalaciones_aparatos_interfonias_camaras`, { params: parametros })
  }
  obtenerEstadoInstalaciones () {
    return this.instanciaAxios.get ("/estado_instalaciones")
  }
  pagarEstanciaProductoPaso1 (parametros) {
    return this.instanciaAxios.get (`/pagar_estancia_producto`, { params: parametros })
  }
  pagarEstanciaProductoPaso2 (datos) {
    return this.instanciaAxios.post (`/pagar_estancia_producto`, datos)
  }

  // informes
  obtenerRepertorioInformes (parametros) {
    return this.instanciaAxios.get (`/repertorio_informes`, { params: parametros })
  }
  obtenerPreparativosInforme (parametros) {
    return this.instanciaAxios.get (`/preparativos_informe`, { params: parametros })
  }
  generarInforme (datos) {
    return this.instanciaAxios.post (`/generar_informe`, datos)
  }

  // interfonia
  interfonia (datos) {
    return this.instanciaAxios.post (`/interfonia`, datos)
  }
}

export default new api();